<template>
  <div id="product-documents-ipr-wording-edit">

    <vs-alert color="danger" title="Wording Document Not Found" :active.sync="not_found">
      <span>Wording Document record with id: {{ id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name: `${ProductCompanyType}.wording-ipr.list`}" class="text-inherit underline">All
        Wording Documents</router-link>
      </span>
    </vs-alert>

    <wording-form
      v-if="model"
      v-model="model"
      ref="form"
      :forms="formReferences"
      :apiModel="apiModel"
      :ProductCompanyType="ProductCompanyType"
      :ProductCompanyType_FK="ProductCompanyType_FK"
    />

    <div class="vx-row" v-if="model">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.back();"
              class="ml-4 mt-2"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="save"
              class="ml-auto mt-2"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import WordingForm from "@/views/pages/product-documents-ipr/wording/WordingForm";
import ProductDocumentEditMixin from "@/components/mixins/ProductDocumentEditMixin";
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

export default {
  name: "WordingIprEdit",
  components: {
    WordingForm
  },
  mixins: [ProductDocumentEditMixin, IprProductCompanyTypeMixin],
  data() {
    return {
      apiModel: this.companyTypeApiModel('productWordingIpr'),
      references: ['RiskCode_FK'],
    };
  },
};
</script>

<style scoped>

</style>
